import { registerMessages } from "../../i18n/runtime";
import { notificationsNavEn } from "./messages.en";
import { notificationsNavEs } from "./messages.es";

// Imported by the module definition and the bell, not by the lazy screens: both draw before any screen has loaded.
registerMessages("en", notificationsNavEn);
registerMessages("es", notificationsNavEs);
